import { useEffect, useRef, useState } from 'react';

import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import { Plus } from '@peacecover/icon';

import { Helmet } from 'react-helmet-async';
import { useGetUserInfo } from '@pocapan/shared/domains/user/ui/hooks/useGetUserInfo';
import useUserProfilesListQuery from '../../components/api/queries/useUserProfilesListQuery';
import { useSelectedTradingCardsStore } from './store/useSelectedTradingCardsStore';
import AddUserProfileV1BottomSheet from '../../components/bottomSheet/AddUserProfileV1BottomSheet';
import SalesTabPanelV2 from './components/SalesTabPanelV2';
import HomeBottomNav from '../components/bar/HomeBottomNav';
import NotificationBadge from '../notifications/components/NotificationBadge';

const TRADING_CATEGORY = 'trading';

export default function TradingPhotoCardSalesPage() {
  const { colorMode } = useColorMode();
  const fabWrapperRef = useRef();
  const navigate = useNavigate();

  const [isShowProfileBottomSheet, setIsShowProfileBottomSheet] = useState(false);

  const { data: user } = useGetUserInfo();
  const tradingUserProfiles = useUserProfilesListQuery(TRADING_CATEGORY);
  const { clearPhotoCards } = useSelectedTradingCardsStore();

  useEffect(() => {
    if (tradingUserProfiles) {
      if (isEmpty(tradingUserProfiles)) {
        setIsShowProfileBottomSheet(true);
      } else if (tradingUserProfiles.length > 1) {
        navigate('/users/merge_profiles');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradingUserProfiles]);

  const onClickSellButton = () => {
    if (!user) return;

    if (user.tradingUserProfile) {
      clearPhotoCards();
      navigate('/new-my-trading-photo-cards/sell');
    } else {
      setIsShowProfileBottomSheet(true);
    }
  };

  return (
    <div className="bg-background min-h-fit pb-[calc(50px+env(safe-area-inset-bottom))] pt-[env(safe-area-inset-top)] bg-scroll h-screen">
      <Helmet>
        <title>{t('tabs.trade')}</title>
        <meta name="theme-color" content={colorMode === 'dark' ? '#0D0E12' : '#FFFFFF'} />
      </Helmet>
      <Header />
      <SalesTabPanelV2 fabWrapperRef={fabWrapperRef} />
      {!isShowProfileBottomSheet && (
        <div
          ref={fabWrapperRef}
          className="fixed bottom-[calc(95px+env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 z-10"
        >
          <button
            type="button"
            onClick={onClickSellButton}
            className="flex items-center justify-center gap-[4px] min-w-[165px] h-[46px] pl-[14px] pr-[18px] py-[13px] rounded-full bg-primary-light dark:bg-primary-dark text-on-primary text-[16px] font-semibold leading-[19px] whitespace-nowrap"
          >
            <Plus size={15} />
            {t('tradingPhotoCardPage.sellPhotoCardButton')}
          </button>
        </div>
      )}
      {isShowProfileBottomSheet && (
        <AddUserProfileV1BottomSheet
          title={t('tradingPhotoCardPage.addProfileBottomSheetTitle')}
          userProfile={user?.tradingUserProfile}
          isShowProfileBottomSheet={isShowProfileBottomSheet}
          setIsShowProfileBottomSheet={setIsShowProfileBottomSheet}
        />
      )}
      <HomeBottomNav tabIndex={1} />
    </div>
  );
}

const Header = () => {
  return (
    <div className="flex flex-row justify-between items-center px-[24px] py-[11px]">
      <h1 className="text-[26px] font-bold text-text-main-lv1 leading-[31px]">{t('tabs.trade')}</h1>
      <NotificationBadge />
    </div>
  );
};
